const scriptName = 'nextit-loader.js';

// Transpilers look explicitly for process.env[KEY] and resolve at build time.
// Don't try to be cute with destructuring here.
let almeApiHostname = process.env.alme_api_hostname || "";
let almeApiProtocol = process.env.alme_api_protocol;

if (!almeApiHostname) {
    const scripts = Array.from(document.getElementsByTagName('script'));
    const match = scripts.find(s => ~s.src.indexOf(scriptName));

    if (match) {
        const link = document.createElement("a");
        link.href = match.src;
        almeApiHostname = link.host;
    } else {
        almeApiHostname = window.location.host;
    }
}

export default {
    AlmeAPI: {
        ALME_API_HOSTNAME: almeApiHostname,
        ALME_API_BASE_PATH: "/AlmeAPI/api/",
        ALME_API_PROTOCOL: almeApiProtocol || "https://",
        ALME_API_REQUEST_TIMEOUT: 10000,
        requestOptions: {
            //https://developer.mozilla.org/en-US/docs/Web/API/Request/mode
            mode: "cors",
            //https://developer.mozilla.org/en-US/docs/Web/API/Request/credentials
            credentials: "same-origin",
        },
    },
    ExtensibleAlmeAPI: {
        liveChat: {
            beginChat: {
                endpoint: "livechat/InitConversation",
            },
            chatEvent: {
                endpoint: "livechat/NotifyChatEvent",
            },
            getChatStatus: {
                endpoint: "livechat/GetLiveChatState",
            },
            getMessages: {
                endpoint: "livechat/GetMessages",
            },
            sendMessage: {
                endpoint: "livechat/SendMessage",
            },
            userEndChat: {
                endpoint: "livechat/EndConversation",
            },
        },
        notificationsApi: 'Notifications/GetNotifications',
        UploadHistoryEndpoint: "HistoryUpload/UploadHistory",
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/alme-api.ts